import { defaultAd300x250, IAdUnit } from "../unit";

export enum FooterEnum {
  DesktopIndexFooterA="Desktop Index Footer A",
  DesktopIndexFooterB="Desktop Index Footer B",
  DesktopIndexFooterC="Desktop Index Footer C",
  MobileFooter="Mobile Footer",
}

export const FooterUnits: {[name in FooterEnum]: IAdUnit} = {
  [FooterEnum.DesktopIndexFooterA]: {
    ...defaultAd300x250,
    sid: "978199",
  },
  [FooterEnum.DesktopIndexFooterB]: {
    ...defaultAd300x250,
    sid: "978200",
  },
  [FooterEnum.DesktopIndexFooterC]: {
    ...defaultAd300x250,
    sid: "978202",
  },
  [FooterEnum.MobileFooter]: {
    ...defaultAd300x250,
    sid: "978307",
  },
};
